/* lcs-headings-faqs.js — FAQs page headings fix (H1 único + UI demote) */
(function () {
  var DEBUG = true;
  function log(){ if(DEBUG && window.console) try{ console.log.apply(console,arguments);}catch(_){} }

  /* ---------- Utils ---------- */
  function currentTemplate(){
    var b=document.body;
    var m=(b.className.match(/template-([a-z0-9\-.]+)/i)||[])[1]||'';
    var dt=b.getAttribute('data-template')||document.documentElement.getAttribute('data-template')||'';
    return (dt||m||'').toLowerCase();
  }
  function isFAQs(){
    // Shopify: page + handle 'faqs'
    var tpl=currentTemplate();
    var ok=(tpl.indexOf('page')===0);
    if(!ok) return false;
    var h=(window.location.pathname.split('/').pop()||'').toLowerCase();
    return (h==='faqs' || tpl.indexOf('faqs')>-1);
  }
  if(!isFAQs()){ log('[LCS-FAQ] Skip on template:', currentTemplate()); return; }
  log('[LCS-FAQ] Running on', currentTemplate());

  /* ----- helpers para degradar / retagear ----- */
  function toPresentational(el){
    if(!el || !/^H[1-6]$/i.test(el.tagName)) return;
    try{
      var d=document.createElement('div');
      for(var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; d.setAttribute(a.name,a.value); }
      d.className=(d.className?d.className+' ':'')+'ui-heading';
      d.setAttribute('role','presentation'); d.setAttribute('aria-hidden','true');
      while(el.firstChild) d.appendChild(el.firstChild);
      el.replaceWith(d);
      log('[LCS-FAQ] Demoted', el.tagName, '→ DIV', d.className);
    }catch(e){ /*noop*/ }
  }
  function retagKeepStyles(el,tag){
    if(!el || el.tagName.toLowerCase()===tag) return el;
    var n=document.createElement(tag);
    for(var i=0;i<el.attributes.length;i++){ var a=el.attributes[i]; n.setAttribute(a.name,a.value); }
    while(el.firstChild) n.appendChild(el.firstChild);
    el.replaceWith(n);
    return n;
  }

  /* ----- 1) Degradar headings de UI (header, drawers, modales, quickshop, predictive search) ----- */
  var UI_SCOPES=[
    '#shopify-section-header','header','.site-header','.header',
    '.drawer','.modal','.modal__content','.cart-drawer','#CartDrawer',
    '.cart-notification','#CartNotification','.ajaxcart','.mini-cart',
    '.predictive-search','[data-predictive-search]',
    '.quick-add','.quickshop','.product-quickshop','#dialogQuickShopTitle'
  ];
  var UI_SELECTOR=UI_SCOPES.map(function(s){return s+' h1,'+s+' h2,'+s+' h3,'+s+' h4,'+s+' h5,'+s+' h6';}).join(',');
  function fixUI(root){
    (root||document).querySelectorAll(UI_SELECTOR).forEach(toPresentational);
  }

  /* ----- 2) Headings vacíos → presentacionales ----- */
  function fixEmpty(root){
    (root||document).querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function(h){
      var t=(h.textContent||'').replace(/\s+/g,'').trim();
      if(!t.length) toPresentational(h);
    });
  }

  /* ----- 3) Hero: H1 = “FAQs” ----- */
  function fixHero(){
    var hero=document.querySelector('.s-header, .banner, [data-section-type*="banner"], .hero');
    if(!hero) return;

    var nodes=hero.querySelectorAll('h1,h2,h3,.s-header__title,.s-header__heading');
    var title=null;
    nodes.forEach(function(n){
      var tx=(n.textContent||'').trim().toLowerCase();
      if(!title && /^faqs?$/.test(tx)) title=n;
    });
    if(!title) title=hero.querySelector('.s-header__title, h1, h2');

    if(title){
      title=retagKeepStyles(title,'h1');
      title.id='page-title';
      title.setAttribute('aria-level','1');
      log('[LCS-FAQ] Hero → H1');
    }

    // Garantizar H1 único dentro de <main>
    var main=document.querySelector('main')||document;
    var canonical=document.getElementById('page-title');
    main.querySelectorAll('h1').forEach(function(h){
      if(canonical && h!==canonical) retagKeepStyles(h,'h2');
    });
  }

  /* ----- 4) Ajustes adicionales específicos FAQs ----- */
  function fixSections(){
    // “We Have Answers” debe quedar como H2
    var answers=document.querySelectorAll('h1,h2,h3,h4,h5,h6');
    answers.forEach(function(n){
      var tx=(n.textContent||'').trim().toLowerCase();
      if(/we have answers/.test(tx)) retagKeepStyles(n,'h2');
    });

    // “Build Your Business with Le Gourmet Factory.” → H2 (sección CTA)
    answers.forEach(function(n){
      var tx=(n.textContent||'').trim().toLowerCase();
      if(/build your business/.test(tx)) retagKeepStyles(n,'h2');
    });

    // Degradar "Quick shop" si aparece
    answers.forEach(function(n){
      var tx=(n.textContent||'').trim().toLowerCase();
      if(tx==='quick shop') toPresentational(n);
    });
  }

  /* ----- run & observe ----- */
  function run(){ fixUI(); fixEmpty(); fixHero(); fixSections(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  new MutationObserver(function(m){
    m.forEach(function(x){
      (x.addedNodes||[]).forEach(function(n){
        if(n && n.nodeType===1){ fixUI(n); fixEmpty(n); fixHero(); fixSections(); }
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
